function WriteReviewTastic(props) {
  return <div id="pr-write" className="pr-write-custom-styles"></div>;
}

export default WriteReviewTastic;
